angular.module('dpw.components').component('dpwLeadsReport', {
    templateUrl: 'dpw-leads-report.html',
    controllerAs: 'ctrl',
    controller: ['$scope', '$filter', 'popup', 'helpers', 'paging', 'dpwLeadsReportService',
        function ($scope, $filter, popup, helpers, paging, dpwLeadsReportService) {
            var self = this;

            self.isAdminSite = RCDPW.isAdminSite;
            self.store = dpwLeadsReportService.store;
            self.datepickers = {};
            self.search = function () {
                self.store.usedCriteria = _.cloneDeep(self.store.inputCriteria);
                pagingHandler.newSearch();
            };

            self.sort = function (keyName, isAsc) {
                helpers.singleFieldSort(self.store.usedCriteria.sortObj, keyName, isAsc);
                searchData();
            };

            var pagingHandler = paging.init($scope, searchData, 'paging', self.store, 'ctrl.store');

            self.clearDate = function (key) {
                self.datepickers[key].clear();
            };

            self.export = function () {
                var now = new Date();
                var dateString = $filter('date')(now, 'yyyyMMddHmmss');
                var newScope = $scope.$new();
                var filename = self.isAdminSite ? 'DPWAdmin-Leads-' : 'Leads-';

                newScope.exportConfig = {name: filename + dateString};
                newScope.callback = callback;

                popup({
                    scope: newScope,
                    directiveName: 'dpw-export-popup',
                    extraClass: 'console-ui'
                });

                function callback() {
                    dpwLeadsReportService.export(newScope.exportConfig.name);
                    newScope.$destroy();
                }
            };

            function searchData() {
                dpwLeadsReportService.search().then(function (data) {
                    pagingHandler.reset(data);
                });
            }
        }]
});
